import { observer } from 'mobx-react';
import React, { useState, useEffect } from 'react';
import { useUDData } from '@udemy/ud-data';
import { sendLabsResumeBannerViewEvent } from './events';
import { LabsLearningBannerStore } from './labs-learning-banner.mobx-store';
import { MultipleLabsLearningBanner } from './multiple-labs-learning-banner.react-component';
import { SingleLabsLearningBanner } from './single-labs-learning-banner.react-component';
const InternalLabsLearningBanner = function (props) {
  const {
    me
  } = useUDData();
  const [store] = useState(() => props.store || new LabsLearningBannerStore());
  useEffect(() => {
    async function initialize() {
      await store.refreshAndRetrieveRunningLabs();
      await store.checkDismissed();
      if (!store.isDismissed && store.firstRunningLab) {
        sendLabsResumeBannerViewEvent(store.firstRunningLab);
      }
    }
    if (me.is_authenticated) {
      initialize();
    }
  }, [me.is_authenticated, store]);
  if (!me.is_authenticated) {
    return null;
  }
  return store.shouldRenderMultipleLabsBanner ? /*#__PURE__*/React.createElement(MultipleLabsLearningBanner, {
    store: store
  }) : /*#__PURE__*/React.createElement(SingleLabsLearningBanner, {
    store: store
  });
};
InternalLabsLearningBanner.displayName = 'LabsLearningBanner';
export const LabsLearningBanner = observer(InternalLabsLearningBanner);
//# sourceMappingURL=labs-learning-banner.react-component.js.map